import React, { createContext, useEffect, useState } from 'react'

// 创建 Context
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const DarkThemeContext = createContext({ bgColor: 'bg-[#102240]', setBgColor: (color: string) => {} })

// ThemeProvider 组件
export const DarkThemeProvider = ({ children }) => {
  const [bgColor, setBgColorInUseState] = useState('bg-[#102240]')

  const setBgColor = (color) => {
    setBgColorInUseState(color)
    localStorage.setItem('theme', color)
  }

  useEffect(() => {
    if (localStorage && localStorage.getItem('theme')) {
      const color = localStorage.getItem('theme')
      if (color.startsWith('bg-')) {
        setBgColor(color)
      }
    }
  }, [])

  return <DarkThemeContext.Provider value={{ bgColor, setBgColor }}>{children}</DarkThemeContext.Provider>
}
